import {VehicleDataAcquisitionStatusDto} from "./vda";
import {PrinterTypeDto as UmsPrinterTypeDto, SalutationTypeDto, UserGroupTypeDto} from "./ums";
import {DocumentTypeDto as SeaDocumentTypeDto, ScanStatusDto} from "./sea";
import {
    DefaultShipmentProcessTypeDto,
    DefaultShipmentTypeDto,
    DefaultShippingDestinationTypeDto,
    ScanDocumentRuleActionTypeDto,
    ScanDocumentRuleFieldTypeDto,
    ShipmentProcessTypeDto as CmsShipmentProcessTypeDto,
    ShipmentTypeDto as CmsShipmentTypeDto,
    ShippingDestinationTypeDto as CmsShippingDestinationTypeDto
} from "./cms";
import {
    DocumentTypeDto as SlsDocumentTypeDto,
    PlacementProcessDocumentExistenceFilterDto,
    PlacementProcessDocumentStatusDto,
    PlacementProcessOriginDto,
    PlacementProcessStatusDto
} from "./sls";
import {
    DocumentTypeDto as FmsDocumentTypeDto,
    ShipmentPackageStatusDto,
    ShipmentProcessTypeDto,
    ShipmentTypeDto,
    ShippingDestinationTypeDto
} from "./fms";
import {
    DataStateDto,
    DocumentTypeDto,
    ReceiptTypeDto,
    ShipmentTypeDto as KpiShipmentTypeDto,
    WeighingTypeDto
} from "./kpi"
import {DocumentTypeDto as VhsDocumentTypeDto, EventTypeDto} from "./vhs";
import {AcquisitionDocumentStatusDto, AcquisitionStatusDto, DataElementTypeDto} from "./sca";
import {StorageTransferReasonDto, StorageTransferStatusDto} from "./sts";

export function convertScaStatus(status: AcquisitionStatusDto) {
    switch (status) {
        case AcquisitionStatusDto.INITIALIZED:
            return 'Gestartet'
        case AcquisitionStatusDto.STORAGE_TRANSFER_ASSIGNED:
            return 'Umlagerung gestartet'
        case AcquisitionStatusDto.STORAGE_TRANSFER_FAILURE:
            return 'Umlagerung fehlgeschlagen'
        case AcquisitionStatusDto.ACQUISITION_READY:
            return 'Bereit zur Erfassung'
        case AcquisitionStatusDto.ACQUISITION_COMPLETED:
            return 'Abgeschlossen'
        case AcquisitionStatusDto.ACQUISITION_COMPLETED_WITH_ERROR:
            return 'Abgeschlossen mit Fehler'
        case AcquisitionStatusDto.ACQUISITION_INVALID_CODE:
            return 'Fehlerhafter Sicherheitscode'
        case AcquisitionStatusDto.ACQUISITION_STORAGE_MERGE:
            return 'Umlagerung nach Dokumenteneingang'
    }
}

export function convertStatus(status: VehicleDataAcquisitionStatusDto) {
    switch (status) {
        case VehicleDataAcquisitionStatusDto.ACQUISITION:
            return 'In Erfassung'
        case VehicleDataAcquisitionStatusDto.TRANSFER:
            return 'Im Transfer'
        case VehicleDataAcquisitionStatusDto.ERROR:
            return 'Fehler'
        case VehicleDataAcquisitionStatusDto.COMPLETED:
            return 'Abgeschlossen'

    }
}

export function exportStsReason(reason: StorageTransferReasonDto) {
    switch (reason) {
        case StorageTransferReasonDto.SECURITY_CODE_ACQUISITION:
            return 'Sicherheitscodeerfassung'
        case StorageTransferReasonDto.STORAGE_MERGE:
            return 'Zusammenführung'
        case StorageTransferReasonDto.STORAGE_MERGE_SECURITY_CODE_ACQUISITION:
            return 'Zusammenführung nach SCA'

    }
}

export function convertStsStatus(status: StorageTransferStatusDto) {
    switch (status) {
        case StorageTransferStatusDto.INITIALIZED:
            return 'Angelegt'
        case StorageTransferStatusDto.FULFILLMENT_ASSIGNED:
            return 'Auslagerung verknüpft'
        case StorageTransferStatusDto.FULFILLMENT_FAILED:
            return 'Auslagerung fehlgeschlagen'
        case StorageTransferStatusDto.FULFILLMENT_FINISHED:
            return 'Auslagerung abgeschlossen'
        case StorageTransferStatusDto.PLACEMENT_ASSIGNED:
            return 'Einlagerung verknüpft'
        case StorageTransferStatusDto.VEHICLE_DATA_ACQUISITION_ASSIGNED:
            return 'Fahrzeugerfassung verknüpft'
        case StorageTransferStatusDto.VEHICLE_DATA_ACQUISITION_FAILED:
            return 'Fahrzeugerfassung fehlgeschlagen'
        case StorageTransferStatusDto.PLACEMENT_READY:
            return 'Einlagerungsbereit'
        case StorageTransferStatusDto.WAITING_FOR_ACTION:
            return 'Warte auf Prozess'
        case StorageTransferStatusDto.FINISHED:
            return 'Abgeschlossen'

    }
}

export function displaySalutation(input?: SalutationTypeDto): string {
    switch (input) {
        case SalutationTypeDto.MR:
            return 'Herr'
        case SalutationTypeDto.MS:
            return 'Frau'
        case SalutationTypeDto.DIVERSE:
            return 'Divers'
    }
    return input || '-'
}

export function displayUserGroup(input?: UserGroupTypeDto) {
    switch (input) {
        case UserGroupTypeDto.UNAUTHORIZED:
            return 'ohne Berechtigung'
        case UserGroupTypeDto.ADMIN:
            return 'Admin'
        case UserGroupTypeDto.ACCOUNTING:
            return 'Abrechnung'
        case UserGroupTypeDto.CLERK:
            return 'Sachbearbeiter'
        case UserGroupTypeDto.SUPPORT:
            return 'Support'
        case UserGroupTypeDto.THIRD_LEVEL_SUPPORT:
            return 'Third-Level'
        case UserGroupTypeDto.VIEWER:
            return 'Anzeige'
    }
    return input || '-'
}

export function displayShipmentType(input?: ShipmentTypeDto | KpiShipmentTypeDto | DefaultShipmentTypeDto | CmsShipmentTypeDto) {
    switch (input) {
        case ShipmentTypeDto.LATE_MORNING:
            return 'bis 10:30 Uhr'
        case ShipmentTypeDto.MORNING:
            return 'bis 9:00 Uhr'
        case ShipmentTypeDto.NOON:
            return 'bis 12:00 Uhr'
        case ShipmentTypeDto.POST:
            return 'Post'
        case ShipmentTypeDto.TRACKED:
            return 'Sendungsverfolgt'
    }
    return input || '-'
}

export function displayShippingDestinationType(input?: ShippingDestinationTypeDto | DefaultShippingDestinationTypeDto | CmsShippingDestinationTypeDto) {
    switch (input) {
        case ShippingDestinationTypeDto.DOMESTIC:
            return 'Inland'
        case ShippingDestinationTypeDto.EU:
            return 'EU'
        case ShippingDestinationTypeDto.NON_EU:
            return 'Nicht EU'
    }
    return input || '-'
}

export function displayReceiptType(input?: ReceiptTypeDto): string {
    if (!input) {
        return '-'
    }
    switch (input) {
        case ReceiptTypeDto.SCAN_COMPLETE:
            return 'Scan'
        case ReceiptTypeDto.ACQUISITION_COMPLETE:
            return 'Erfasst'
        case ReceiptTypeDto.PLACEMENT_COMPLETE:
            return 'Eingelagert'
        case ReceiptTypeDto.SCAN_RECORD_COMPLETE:
            return 'Scan'
        case ReceiptTypeDto.ACQUISITION_RECORD_COMPLETE:
            return 'Erfasst'
        case ReceiptTypeDto.PLACEMENT_RECORD_COMPLETE:
            return 'Eingelagert'
    }
}

export function displayShipmentProcessType(input?: ShipmentProcessTypeDto | DefaultShipmentProcessTypeDto | CmsShipmentProcessTypeDto) {
    switch (input) {
        case ShipmentProcessTypeDto.INTERNAL:
            return 'Interner Versand'
        case ShipmentProcessTypeDto.STORAGE_TRANSFER_SCA:
            return 'Sicherheitscodeerfassung'
        case ShipmentProcessTypeDto.STORAGE_TRANSFER_SCA_FINISH:
            return 'Umlagerung Sicherheitscodeerfassung'
        case ShipmentProcessTypeDto.MVR_ON:
            return 'Zulassung ON'
        case ShipmentProcessTypeDto.REGULAR:
            return 'Allgemein'
        case ShipmentProcessTypeDto.STORAGE_TRANSFER:
            return 'Umlagerung'
        case ShipmentProcessTypeDto.MVR:
            return 'Zulassung'
    }
    return input || '-'
}

export function displayShipmentPackageStatus(input?: ShipmentPackageStatusDto): string {
    switch (input) {
        case ShipmentPackageStatusDto.CLOSED:
            return 'Abgeschlossen'
        case ShipmentPackageStatusDto.CLOSING:
            return 'Im Abschluss'
        case ShipmentPackageStatusDto.ACTIVE:
            return 'Offen'
    }
    return input || '-'
}

export function convertScanStatus(status: ScanStatusDto | undefined): string {
    switch (status) {
        case ScanStatusDto.IN_PROGRESS:
            return 'Noch in Verarbeitung bei S&E'
        case ScanStatusDto.STACK_COMPLETE:
            return 'Stapel fertig übergeben von S&E'
        case ScanStatusDto.AMBIGUOUS_FIN:
            return 'FIN ist mehrdeutig'
        case ScanStatusDto.NO_VIN:
            return 'FIN konnte nicht ermittelt werden'
        case ScanStatusDto.VIN_CHECK_DIGIT_MALFORMED:
            return 'FIN Prüfziffer konnte nicht ermittelt werden'
        case ScanStatusDto.COMPLETE:
            return 'An Kunde übermittelt und OK'
        case ScanStatusDto.BAD_SCAN:
            return 'Scan des Dokumentes ist ungenügend'
        case ScanStatusDto.NO_ENVELOPE:
            return 'Briefumschlag konnte nicht ermittelt werden'
    }
    return `${status}`
}


export function convertScanDocumentRuleAction(input: ScanDocumentRuleActionTypeDto | undefined): string {
    switch (input) {
        case ScanDocumentRuleActionTypeDto.DESTROY:
            return 'Zerstören'
    }
    return input || '-'
}

export function convertScanDocumentRuleField(input: ScanDocumentRuleFieldTypeDto | undefined): string {
    switch (input) {
        case ScanDocumentRuleFieldTypeDto.DOCUMENT_TYPE:
            return 'Dokumententyp'
    }
    return input || '-'
}

export function mapDocumentTypeStatus(input: EventTypeDto): string {
    switch (input) {
        case EventTypeDto.SHIPMENT_ITEM_LOST:
            return 'Dokument nicht auffindbar'
        case EventTypeDto.SHIPMENT_ITEM_CANCELED:
            return 'Storniert'
        case EventTypeDto.SHIPMENT_ITEM_INITIALIZED:
            return 'Initialisiert'
        case EventTypeDto.INITIALIZED:
            return 'Initialisiert'
        case EventTypeDto.STORED:
            return 'Eingelagert'
        case EventTypeDto.RELEASE_PREPARED:
            return 'Auslagerung vorgemerkt'
        case EventTypeDto.RELEASED:
            return 'Ausgelagert'
        case EventTypeDto.SCAN_COMPLETE:
            return 'Scan abgeschlossen'
        case EventTypeDto.VEHICLE_ACQUISITION:
            return "Erfassung abgeschlossen"
        case EventTypeDto.VEHICLE_ACQUISITION_INITIALIZED:
            return 'Erfassung gestartet'
        case EventTypeDto.VEHICLE_ACQUISITION_ERROR:
            return 'Erfassung fehlerhaft'
        case EventTypeDto.PLACEMENT:
            return 'Einlagerung'
        case EventTypeDto.SHIPMENT:
            return 'Versand'
        case EventTypeDto.SHIPMENT_CLOSED:
            return 'Versand abgeschlossen'
        case EventTypeDto.LAST_SCAN:
            return 'Last Scan'
    }
}

export function convertDocumentType(input: FmsDocumentTypeDto | SeaDocumentTypeDto | SlsDocumentTypeDto | VhsDocumentTypeDto | DocumentTypeDto | DataElementTypeDto | string | undefined): string {

    switch (input) {
        case FmsDocumentTypeDto.CONTRACT:
            return 'Vertrag'
        case FmsDocumentTypeDto.SALARY_STATEMENT:
            return 'Gehaltsnachweis'
        case FmsDocumentTypeDto.ID_CARD:
            return 'Identitätsnachweis'
        case FmsDocumentTypeDto.OTHER:
            return 'Sonstiges';
        case FmsDocumentTypeDto.COR_I:
            return 'ZB1'
        case FmsDocumentTypeDto.COR_II:
            return 'ZB2'
        case FmsDocumentTypeDto.COC:
            return 'CoC'
        case FmsDocumentTypeDto.ABE:
            return 'ABE'
        case FmsDocumentTypeDto.CERT:
            return 'Gutachten'
        case SeaDocumentTypeDto.ENVELOPE:
            return 'Briefumschlag'
        case SeaDocumentTypeDto.COVER_LETTER:
            return 'Anschreiben'
        case FmsDocumentTypeDto.CAR_KEY:
            return 'Schlüssel'
        case FmsDocumentTypeDto.RADIO_CODE:
            return 'Radiocode'
        case FmsDocumentTypeDto.WARRANTY:
            return 'Garantiekarte'
        case FmsDocumentTypeDto.LICENSE_PLATE_FRONT:
            return 'Kennzeichen Vorne'
        case FmsDocumentTypeDto.LICENSE_PLATE_REAR:
            return 'Kennzeichen Hinten'
    }
    return input || '-'
}

export function convertPlacementProcessStatus(input: PlacementProcessStatusDto | undefined): string {
    if (!input) {
        return '-'
    }
    switch (input) {
        case PlacementProcessStatusDto.CLOSING:
            return 'Abschluss'
        case PlacementProcessStatusDto.CLOSING_BATCH:
            return 'Abschluss'
        case PlacementProcessStatusDto.ACTIVE:
            return 'Offen'
        case PlacementProcessStatusDto.CLOSED:
            return 'Abgeschlossen'
    }
}

export function convertPlacementProcessOrigin(input: PlacementProcessOriginDto | undefined): string {
    if (!input) {
        return '-'
    }
    switch (input) {
        case PlacementProcessOriginDto.SEA:
            return 'Scandatenimport'
        case PlacementProcessOriginDto.VDA:
            return 'Fahrzeugerfassung'
        case PlacementProcessOriginDto.STS:
            return 'Umlagerung'
        case PlacementProcessOriginDto.SLS:
            return 'Manuelle Einlagerung'
    }
}

export function convertScaDocumentStatus(status: AcquisitionDocumentStatusDto) {
    switch(status) {
        case AcquisitionDocumentStatusDto.INITIALIZED:
            return "Initialisiert"
        case AcquisitionDocumentStatusDto.READ:
            return "Erfasst"
        case AcquisitionDocumentStatusDto.ERROR_NO_CODE:
            return "Code nicht vorhanden"
        case AcquisitionDocumentStatusDto.ERROR_NOT_READABLE:
            return "Code nicht lesbar"
        case AcquisitionDocumentStatusDto.CODE_INVALID:
            return "Code fehlerhaft"
    }
}

export function convertPlacementProcessDocumentExistence(input: PlacementProcessDocumentExistenceFilterDto | undefined): string {
    switch (input) {
        case PlacementProcessDocumentExistenceFilterDto.EXISTS:
            return 'Vorhanden'
        case PlacementProcessDocumentExistenceFilterDto.NOT_EXISTS:
            return 'Nicht vorhanden'
    }
    return input || '-'
}

export function convertPlacementProcessDocumentStatus(input: PlacementProcessDocumentStatusDto): string {
    switch (input) {
        case PlacementProcessDocumentStatusDto.PROCESSING:
            return 'Verarbeitung'
        case PlacementProcessDocumentStatusDto.READY:
            return 'Einlagerungsfähig'
        case PlacementProcessDocumentStatusDto.CLARIFICATION:
            return 'Klärfall'
        case PlacementProcessDocumentStatusDto.ANNOUNCED:
            return 'Angekündigt'
        case PlacementProcessDocumentStatusDto.ANNOUNCEMENT_REVOKED:
            return 'Ankündigung Zurückgenommen'
    }
}

export function convertWeighingType(input: WeighingTypeDto): string {
    switch (input) {
        case WeighingTypeDto.INCOMING:
            return 'Erfassung'
        case WeighingTypeDto.BACKLOG:
            return 'Rückstand'
    }

}

export function convertDataState(input: DataStateDto): string {
    switch (input) {
        case DataStateDto.INITIALIZED:
            return 'Angekündigt'
        case DataStateDto.STORED:
            return 'Eingelagert'
        case DataStateDto.RELEASE_PREPARED:
            return 'Auslagerung vorgemerkt'
        case DataStateDto.RELEASED:
            return 'Ausgelagert'
    }
}

export function displayPrinterType(type?: UmsPrinterTypeDto) {
    switch (type) {
        case UmsPrinterTypeDto.DOCUMENT:
            return `Dokumentendrucker`
        case UmsPrinterTypeDto.VLOG:
            return `Versandlabeldrucker`
        case UmsPrinterTypeDto.ZEBRA:
            return `Labeldrucker`
    }
    return type || '-'
}
